import { render, staticRenderFns } from "./OverviewMappingSalesRepAssignment.vue?vue&type=template&id=1596db00"
import script from "./OverviewMappingSalesRepAssignment.vue?vue&type=script&lang=js"
export * from "./OverviewMappingSalesRepAssignment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports